// kids-task-voice 型定義

export type Level = 'lv1' | 'lv2' | 'lv3';

export type SpeechEngine = 'web-speech' | 'openai-tts' | 'elevenlabs';

export type ReactionVerdict = 'positive' | 'negative' | 'ambiguous' | 'silent';

/** Lv1: 単発時刻アナウンス */
export interface Lv1Task {
  id: string;
  level: 'lv1';
  /** HH:mm 形式 */
  time: string;
  message: string;
  /** 曜日（0=日 〜 6=土）。空配列なら毎日 */
  daysOfWeek: number[];
  enabled: boolean;
  createdAt: number;
}

/** Lv2: 段階予告（30/15/5/0分前） */
export interface Lv2Task {
  id: string;
  level: 'lv2';
  /** 本イベント時刻 HH:mm */
  eventTime: string;
  /** イベント名（「習い事」「お風呂」など） */
  title: string;
  /** カスタムメッセージ（空ならテンプレ自動生成） */
  customMessages?: {
    pre30?: string;
    pre15?: string;
    pre5?: string;
    onTime?: string;
  };
  daysOfWeek: number[];
  enabled: boolean;
  createdAt: number;
}

/** Lv3: 双方向対話タスク（Lv2 + 対話） */
export interface Lv3Task {
  id: string;
  level: 'lv3';
  eventTime: string;
  title: string;
  daysOfWeek: number[];
  enabled: boolean;
  createdAt: number;
}

export type AnyTask = Lv1Task | Lv2Task | Lv3Task;

/** 子どもの応答ログ */
export interface ReactionLog {
  id: string;
  taskId: string;
  taskTitle: string;
  level: Level;
  /** イベント発火時刻（Unix ms） */
  firedAt: number;
  /** アナウンス内容 */
  announcement: string;
  /** 子どもの応答テキスト（無音なら空） */
  reply?: string;
  /** 判定結果（Lv3のみ） */
  verdict?: ReactionVerdict;
  /** 無視カウント（Lv3のみ） */
  ignoreCount?: number;
}

export interface AppSettings {
  speechEngine: SpeechEngine;
  /** OpenAI TTS / Claude を呼ぶPages Functionのベース */
  apiBase?: string;
  /** ElevenLabsボイスID（オプション） */
  elevenLabsVoiceId?: string;
  /** ElevenLabs APIキー（クライアント保存・実験用） */
  elevenLabsApiKey?: string;
  /** 音量（0-1） */
  volume: number;
  /** 再生速度（0.5-2.0） */
  rate: number;
}

export const DEFAULT_SETTINGS: AppSettings = {
  speechEngine: 'web-speech',
  apiBase: '',
  volume: 1.0,
  rate: 1.0,
};
